import React, { useEffect, useState } from 'react';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
import { purchases } from '../data/content';
export function UrgencyBanner() {
  const [visible, setVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(purchases[0]);
  useEffect(() => {
    const showPopup = () => {
      setCurrentPurchase(purchases[Math.floor(Math.random() * purchases.length)]);
      setVisible(true);
      window.setTimeout(() => setVisible(false), 6500);
    };
    const initialTimer = window.setTimeout(showPopup, 3500);
    const interval = window.setInterval(showPopup, 18000);
    return () => {
      window.clearTimeout(initialTimer);
      window.clearInterval(interval);
    };
  }, []);
  if (!visible) return null;
  return <aside className="pointer-events-none fixed bottom-3 left-3 right-3 z-50 flex animate-slide-in justify-center sm:left-auto sm:right-4 sm:justify-end" aria-live="polite" data-id="element-149" data-mp="3b5wnwft3busr">
      <div className="pointer-events-auto relative w-full max-w-[280px] overflow-hidden rounded-lg border-2 border-brand-green bg-brand-navy p-2.5 pr-7 text-white shadow-[0_8px_24px_rgba(6,30,51,0.5)]" data-id="element-150" data-mp="1gwcbar540j6j">
        <div className="absolute inset-x-0 top-0 h-1 bg-brand-red" data-id="element-151" data-mp="22m6nkx21qnk2" />
        <button onClick={() => setVisible(false)} aria-label="Chiudi notifica di acquisto" className="absolute right-1.5 top-1.5 rounded p-0.5 text-white/60 hover:text-white focus:outline-none focus:ring-2 focus:ring-brand-green" data-id="element-152" data-mp="1xpg748mbxpy4">
          <XIcon className="h-3.5 w-3.5" data-id="element-153" data-mp="2le7veowsto5m" />
        </button>
        <div className="flex items-center gap-2.5" data-id="element-154" data-mp="2lcoecw3bj92s">
          <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-brand-green bg-brand-green/20" data-id="element-155" data-mp="2geczu822wae8">
            <ShoppingBagIcon className="h-4 w-4 text-brand-green" aria-hidden="true" data-id="element-156" data-mp="2cfvtvrue95ye" />
          </div>
          <div className="leading-tight" data-id="element-157" data-mp="14y4zmda4db5q">
            <p className="text-[11px] font-bold" data-id="element-158" data-mp="10yea0cwbx12s">{currentPurchase.name}</p>
            <p className="text-[10px] font-medium text-white/70" data-id="element-159" data-mp="12ftdhb1hcwp1">da {currentPurchase.location}</p>
            <p className="mt-0.5 font-heading text-[10px] font-extrabold uppercase text-brand-green" data-id="element-160" data-mp="17ewdgh2lscq5">
              ha appena acquistato PADEL MASTER PRO™
            </p>
          </div>
        </div>
      </div>
    </aside>;
}